import { A4uChevronLeft as IconComponent } from '@adobe/react-spectrum-workflow/dist/ChevronLeft.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function ChevronLeft(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}